import { Button } from "@chakra-ui/button";
import {
    Box, Stack, Flex, Center, Heading, Text,
    GridItem,
    Grid,
    Container,
} from "@chakra-ui/layout";
import {
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalBody,Alert,
    ModalContent,
    FormControl,
    Input,
    ModalCloseButton,
    FormLabel,
    ModalFooter,
    Select,
    IconButton,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Tabs, TabList, TabPanels, Tab, TabPanel,
    theme,
    Wrap,
    useColorModeValue,
    InputGroup,
    InputRightAddon,
    Link,
    Code,
    ListItem, ListIcon, OrderedList,
    TagLabel, Tag,
    Switch,
    NumberInput, NumberInputField,
    useMediaQuery,
    AlertIcon
} from "@chakra-ui/react"

import NextLink from "next/link";
import { firebaseClient } from "../../firebaseClient";

import Tweets from "components/tweets";

import React, { useEffect } from "react";

import { useSession } from "next-auth/client";
import { AddIcon, QuestionOutlineIcon } from '@chakra-ui/icons';

import ProtectedRoute from "components/protected-route";
import { AccountSwitcher } from "components/account";
import { getList, deleteList } from "controllers/bookmark";
import PuffLoader from "react-spinners/PuffLoader";
import { useRouter } from "next/dist/client/router";
import { TweetContext } from "../../context/tweetContext";
import { getAccount, updateUser, getAuthUrl } from "../../utils/sessionHelper";
import { ImportTweet } from "components/popups/importTweet";
import { useOnboardingSteps } from "components/onboard-panel/useOnboardingSteps";
import { useFirebaseUser } from "utils/useFirebaseUser";
import { AskAuth } from "components/ask-auth";
import { textStyle } from "theme/names";
import { ImportIcon } from "components/icons/ImportIcon";

const selectedTabStyle = {
    borderBottom: "solid 2px" + theme.colors.blue[300],
    color: theme.colors.blue[300],
};


export const Evergreen = () => {

    const [session, loading] = useSession();
    const isAuthenticated = useFirebaseUser();
    const [savedTweet, setSavedTweet] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [tweets, setTweets] = React.useState([]);
    const [refresh, refresher] = React.useState({});
    const [isAutoEvergreen, setIsAutoEvergreen] = React.useState<boolean>(false);
    const [noOfLikes, setNoOfLikes] = React.useState<number>(100);
    const tweetContext: any = React.useContext(TweetContext);
    const router = useRouter();
    const { updateOnboardSteps } = useOnboardingSteps();
    const [isSmallerThan1000px] = useMediaQuery("(max-width: 1000px)");
    const [isSmallerThan1200px] = useMediaQuery("(max-width: 1200px");
    const { isOpen, onOpen, onClose } = useDisclosure();
    const schedules = getAccount(session)?.schedule;

    const getSavedTweets = async () => {
        // console.log("getSavedTweets");
        // console.log(session?.user?.uid);
        // console.log(loading);
        if (session?.user?.uid) {
            setIsLoading(true);

            // console.log("idAccount: " + getAccount(session).idAccount);
            // console.log("lists: ", session?.user?.data?.lists);
            let list = session?.user?.data?.lists?.find(x => x.idAccount == getAccount(session).idAccount);
            if (list) {
                //@ts-ignore
                const resTweets = await getList(getAccount(session).id, list.id);
                //@ts-ignore
                // const ids = savedTweets.map((tweet) => tweet.id_str);
                setTweets(resTweets);
    
                //@ts-ignore
                setSavedTweet(resTweets);
            }
            // else {
            //     toast.error("An error happened, contact us at team@tweethunter.io for help");
            // }
            setIsLoading(false);
        }
    };

    const handlechange = async (value: string) => {
        const intValue = parseInt(value) || 0
        setNoOfLikes(intValue)
        await updateUser(session, { autoAddEvergreenTrigger: intValue })
    }

    const handleToggle = async () => {
        const currentToggleValue = !isAutoEvergreen
        setIsAutoEvergreen(currentToggleValue)
        await updateUser(session, { isAutoAddEvergreen: currentToggleValue, autoAddEvergreenTrigger: noOfLikes })
    }

    const setAutoAdd = async () => {
        const { isAutoAddEvergreen, autoAddEvergreenTrigger } = getAccount(session);

        if (isAutoAddEvergreen === undefined) {
            await updateUser(session, { isAutoAddEvergreen: false, autoAddEvergreenTrigger: 100 })
        }

        setIsAutoEvergreen(!!isAutoAddEvergreen)
        setNoOfLikes(autoAddEvergreenTrigger ?? noOfLikes)
    }

    useEffect(() => {
        if (isAuthenticated) {
            getSavedTweets();
            setAutoAdd()
        }
    }, [refresh, isAuthenticated]);

    // update onboarding task status
    useEffect(() => {
        const hasEvergreenSchedule = !!schedules?.filter(x => x.isEvergreen)?.length;
        if (hasEvergreenSchedule && tweets?.length > 0) {
            updateOnboardSteps("evergreen", "engage");
        }
    }, [schedules, session]);

    return (
        <Box w="full">
            {
                // getAccount(session)?.idAccount == getAccount(session)?.id ? (

                    session?.user?.data?.thWriteAccessToken ? (

                        (session?.user?.data?.hasEvergreen && session?.user?.data?.lists?.some(x => x.idAccount == getAccount(session).idAccount)) || isLoading ? (

                            isLoading ? (
                                <Center pt={10}>
                                    <PuffLoader color={"hsl(203, 100%, 36%)"} loading={isLoading} css="display: block; margin: 0 auto; border-color: red;" size={50} />
                                </Center>
                            ) : (
                                tweets?.length > 0 && !loading ? (
                                    <>
                                        <Flex flexDirection="column" w="full" maxW={"1000px"}>
                                            <Flex justifyContent="space-between" direction={isSmallerThan1200px ? "column-reverse" : "row"} alignItems="flex-end" gap={2}>
                                                <FormControl mt={isSmallerThan1200px ? 3 : 0} 
                                                    display="flex" 
                                                    justifyContent={isSmallerThan1200px ? "flex-end" : "flex-start"}
                                                    maxW="600px"
                                                >
                                                    <Flex direction={isSmallerThan1000px ? "column" : "row"}>
                                                        <Box display="flex" gap={2} alignItems={"center"}>
                                                            <Text  textStyle="body.medium.standard">Add tweet automatically</Text>
                                                            <Switch
                                                                // m={2}
                                                                mr={4}
                                                                isChecked={isAutoEvergreen}
                                                                onChange={handleToggle}
                                                            />
                                                        </Box>

                                                        {
                                                            isAutoEvergreen && (
                                                                <Flex direction="row" alignItems="center" gap={2}>
                                                                    <Text
                                                                    textStyle={textStyle["body.medium.light"]}
                                                                    >Add tweets when they reach</Text>
                                                                    <NumberInput
                                                                        value={noOfLikes}
                                                                        onChange={handlechange}
                                                                        size="sm"
                                                                        width="80px"
                                                                        min={0}
                                                                        // ml={2}
                                                                        // ml={2}
                                                                        // @ts-ignore
                                                                        style={{ "--number-input-stepper-width": "0" }}
                                                                    >
                                                                        <NumberInputField borderRadius="6px" pr="2" pl="2" />
                                                                    </NumberInput>
                                                                    <Text textStyle="body.medium.light" >likes</Text>
                                                                </Flex>
                                                            )
                                                        }
                                                    </Flex>
                                                </FormControl>
                                                <Wrap justify="flex-end">
                                                    <Button
                                                        as="a"
                                                        target="_blank"
                                                        href="https://intercom.help/TaplioAndTweetHunter/en/articles/9857486-how-do-evergreen-tweets-work"
                                                        leftIcon={<QuestionOutlineIcon />}
                                                        variant={"secondary"}
                                                    >
                                                        Help
                                                    </Button>
                                                    <Button ml={2} onClick={onOpen}
                                                    leftIcon={ImportIcon}
                                                    variant="secondary"
                                                    >
                                                        Import Tweets
                                                    </Button>
                                                    <Button
                                                        ml={2}
                                                        onClick={() => { tweetContext.onOpenEditSchedule() }}
                                                        variant="secondary"
                                                    >
                                                        Edit Evergreen Schedule
                                                    </Button>
                                                </Wrap>
                                            </Flex >
                                            {
                                                !getAccount(session)?.schedule?.filter(x => x.isEvergreen)?.length && (
                                                    <Flex justifyContent={"center"}>
                                                        {/* <Tag m={5} p={2} cursor="pointer" colorScheme="orange" borderRadius="full" size="md" onClick={() => { tweetContext.onOpenEditSchedule() }}> */}
                                                            {/* <TagLabel textStyle="body.medium.standard"> */}
                                                        <Alert status="info" mt="4" w="fit-content">
                                                            <AlertIcon />
                                                                To use Evergreen, add an Evergreen slot in your queue.
                                                                </Alert>
                                                            {/* </TagLabel> */}
                                                        {/* </Tag> */}
                                                    </Flex>
                                                )
                                            }
                                            {/* <Center mt={5}> */}
                                            {/* <Wrap mb={0} mt={0} width="100%" justify="flex-start" spacing="16px"> */}
                                                <Tweets
                                                    savedTweet={savedTweet}
                                                    tweets={tweets}
                                                    refresher={refresher}
                                                    refresh={refresh}
                                                    disableHideButton={true}
                                                    disableEmbed={true}
                                                    disableTweetCount={false}
                                                    />
                                                {/* </Wrap> */}
                                            {/* </Center> */}
                                        </Flex>
                                    </>
                                ) : (
                                    <Center mt={10}>
                                        <Stack>
                                            <Text
                                                m={10}
                                                textAlign="center"
                                                fontSize="xl"
                                                fontWeight={500}
                                                textStyle={textStyle["h2.bold.standard"]}
                                            >
                                                No evergreen tweets
                                            </Text>
                                                <OrderedList mt={10} pl={10} maxW={"600px"}
                                                    textStyle={textStyle["body.medium.light"]}
                                                    spacing={2}
                                                >
                                                <ListItem>Head to the <Button size="xs" fontSize="xs"  onClick={() => { router.push("/search?filters=0"); }} variant="secondary">Search</Button> section</ListItem>
                                                <ListItem>Search with @{getAccount(session)?.twUserName}</ListItem>
                                                <ListItem>Add the tweets you like in the "evergreen" collection</ListItem>
                                                <ListItem>Those tweets will be retweeted based on your evergreen schedule <Button size="xs" fontSize="xs" onClick={() => { tweetContext.onOpenEditSchedule() }} variant="secondary">Edit</Button></ListItem>
                                            </OrderedList>
                                        </Stack>
                                    </Center>
                                )
                            )
                        ) : (
                            <Flex flexDirection="column" alignItems="center">
                                <Container>
                                <Text
                                    textStyle={textStyle["h2.bold.standard"]}
                                    mt={10} fontSize="lg">Want to use evergreen tweets?</Text>
                                <Text m={7} fontSize="md"
                                    textStyle={textStyle["body.medium.light"]}
                                    >Evergreen tweet let you choose some of your best tweet that will be automatically retweeted based on your evergreen schedule.</Text>
                                <Button
                                    variant={"primary"}
                                    onClick={async () => {
                                        if (session?.user?.uid) {
                                            setIsLoading(true);
                                            // console.log("activate evergreen");
                                            const db = firebaseClient.firestore();
                                            let lists = session.user.data.lists;

                                            let nextId = getAccount(session).lists && getAccount(session).lists?.length > 0 ? Math.min(...getAccount(session).lists.map(x => x.id)) - 1 : -2;
                                            let newList = { name: "@" + getAccount(session).twUserName, id: nextId, isEvergreen: true, idAccount: getAccount(session).idAccount };
                                            lists.unshift(newList);

                                            await db.collection("users").doc(session.user.uid).update({ hasEvergreen: true, lists: lists });
                                            session.user.data.hasEvergreen = true;
                                            refresher({});
                                            // console.log("finish activate evergreen");
                                            setIsLoading(false);
                                        }
                                    }}
                                >
                                    Activate
                                </Button>
                                </Container>
                            </Flex>
                        )
                    ) : (
                        <AskAuth />
                    )
                // ) : (
                //     <Center mt={20} display="flex" flexDirection="column">
                //         <Text fontWeight="600">Evergreen is only supported on your main account</Text>
                //     </Center>
                // )
            }
            <ImportTweet isOpen={isOpen} onClose={onClose} refresher={refresher} selectedListId={session?.user?.data?.lists?.find(x => x.idAccount == getAccount(session).idAccount)?.id} />
        </Box>
    )

}